import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=d590c5be&"
import script from "./Collect.vue?vue&type=script&lang=js&"
export * from "./Collect.vue?vue&type=script&lang=js&"
import style0 from "./Collect.vue?vue&type=style&index=0&id=d590c5be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports